import { InquiryToCustomer } from "../types/InquiryToCustomer";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { HydraCollectionResult } from "../types/HydraCollectionResult";
import { fetchCollection, queryKeys } from "../services/ReactQuery/reactQueryService";

import { ProductUnion } from "../types/ProductUnion";
import dayjs from "dayjs";

export const buildInquiryShortText = (inquiryToCustomer: InquiryToCustomer) => {
  switch (inquiryToCustomer.statusText) {
    case "open":
      return (
        "Offene Anfrage an Mandantschaft: Am " +
        dayjs(inquiryToCustomer.created).format("DD.MM.YYYY") +
        " wurde eine Anfrage von " +
        inquiryToCustomer.createdByFullname +
        " gestellt, die bisher nicht beantwortet wurde."
      );
    case "inProgress":
      return "Termin-Anfrage an Mandantschaft: Termin wurde gebucht. Wenn der Termin erfolgreich stattgefunden hat, wird die Anfrage automatisch erledigt.";
    case "overdue":
      return (
        "Überfällige Anfrage an Mandantschaft: Am " +
        dayjs(inquiryToCustomer.created).format("DD.MM.YYYY") +
        " wurde eine Anfrage von " +
        inquiryToCustomer.createdByFullname +
        " gestellt, die bisher nicht bis zum " +
        dayjs(inquiryToCustomer.deadline).format("DD.MM.YYYY") +
        " beantwortet wurde."
      );
  }
};

export const useInquiry = (product: ProductUnion | null)=> {
  const queryClient = useQueryClient();

  let inquiryToCustomerFilter = {
    productId: product?.id,
    "status[lt]": 40,
  };

  const { data: inquiryToCustomerCollection  } = useQuery<HydraCollectionResult<InquiryToCustomer>>({
    queryKey: queryKeys.collection("inquiry_to_customers", inquiryToCustomerFilter),
    queryFn: () => fetchCollection("inquiry_to_customers", inquiryToCustomerFilter),
    enabled: !!product
  });

  const refreshInquiryToCustomerCollection = async () => {
    return queryClient.invalidateQueries({
      queryKey: queryKeys.collection("inquiry_to_customers", inquiryToCustomerFilter)
    });
  };

  return { inquiryToCustomerCollection, refreshInquiryToCustomerCollection };
}
